import { Breadcrumbs, Button, Text } from '@actualtysoft/ui-kit';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import trefle from 'assets/images/trefle-actual-rouge.png';

const Error404 = () => {
  return (
    <Box sx={{ mt: -2 }}>
      <Breadcrumbs
        links={[{ title: 'Dashboard', link: '/' }]}
        currentPage="404 Not found"
      />
      <Card sx={{ mt: 2 }}>
        <CardContent sx={{ textAlign: 'center' }}>
          <img width={150} src={trefle} alt="404" />

          <Stack spacing={0} direction="column" sx={{ my: 3 }}>
            <Box color="#e20e28" sx={{ fontSize: 60 }}>
              Oups !
            </Box>
            <Text color="#e20e28" variant="h4">
              Erreur 404
            </Text>
          </Stack>
          <Button
            variant="primary"
            color="error"
            href="/"
            sx={{ mt: 3 }}
            role="button"
          >
            Retour au Dashboard
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Error404;
